import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.title',
    defaultMessage: 'Assessment System',
  },
  greeting: {
    id: 'app.greeting',
    defaultMessage: 'Hello, ',
  },
  navbarEditLabel: {
    id: 'app.navbar.editLabel',
    defaultMessage: 'Edit',
  },
  navbarProfileLabel: {
    id: 'app.navbar.profileLabel',
    defaultMessage: 'My profile',
  },
  navbarConfigurationLabel: {
    id: 'app.navbar.configurationLabel',
    defaultMessage: 'Configurations',
  },
  navbarLogoutLabel: {
    id: 'app.navbar.logoutLabel',
    defaultMessage: 'Logout',
  },
  sidebarControlPanel: {
    id: 'app.sidebar.controlPanel',
    defaultMessage: 'Control Panel',
  },
  sidebarConfiguration: {
    id: 'app.sidebar.configuration',
    defaultMessage: 'Settings',
  },
  sidebarReports: {
    id: 'app.sidebar.reports',
    defaultMessage: 'Reports',
  },
  sidebarOnlineSimulated: {
    id: 'app.sidebar.onlineSimulated',
    defaultMessage: 'Online simulated',
  },
  sidebarSimulated: {
    id: 'app.sidebar.simulated',
    defaultMessage: 'Simulated',
  },
  sidebarStudentSimulated: {
    id: 'app.sidebar.studentSimulated',
    defaultMessage: 'Simulated',
  },
  sidebarUnits: {
    id: 'app.sidebar.units',
    defaultMessage: 'Units',
  },
  sidebarProfiles: {
    id: 'app.sidebar.profiles',
    defaultMessage: 'Profiles',
  },
  sidebarClassesStudents: {
    id: 'app.sidebar.classesStudents',
    defaultMessage: 'Classes and Students',
  },
  sidebarGeneralPanel: {
    id: 'app.sidebar.generalPanel',
    defaultMessage: 'General panel',
  },
  sidebarNetworkPanel: {
    id: 'app.sidebar.networkPanel',
    defaultMessage: 'Executive Panel',
  },
  contact: {
    id: 'app.AppFooter.contact',
    defaultMessage: 'Contact',
  },
  privacyPolicy: {
    id: 'app.AppFooter.privacyPolicy',
    defaultMessage: 'Privacy policy',
  },
  cookiesPolicy: {
    id: 'app.AppFooter.cookiesPolicy',
    defaultMessage: 'Cookies policy',
  },
  termsOfUse: {
    id: 'app.AppFooter.termsOfUse',
    defaultMessage: 'Terms of use',
  },
  cookiesSettings: {
    id: 'app.AppFooter.cookiesSettings',
    defaultMessage: 'Cookies settings',
  },
  generalText: {
    id: 'app.AppCookiesBanner.generalText',
    defaultMessage:
      'We use cookies and other proprietary and third-party technologies to properly and safely operate our website and personalize its content. We also use them to analyze your browsing experience and to adapt advertising to your tastes and preferences.',
  },
  rejectOrConfig: {
    id: 'app.AppCookiesBanner.rejectOrConfig',
    defaultMessage: 'Reject or config',
  },
  acceptAll: {
    id: 'app.AppCookiesBanner.acceptAll',
    defaultMessage: 'Accept all',
  },
  configInfo: {
    id: 'app.AppCookiesConfig.configInfo',
    defaultMessage: 'Here you can set your cookies, more information:',
  },
  technicalCookies: {
    id: 'app.AppCookiesConfig.technicalCookies',
    defaultMessage: 'Technical cookies',
  },
  descriptionTechnicalCookies: {
    id: 'app.AppCookiesConfig.descriptionTechnicalCookies',
    defaultMessage:
      'These cookies are necessary for the website to function and cannot be disabled.',
  },
  cookiesCustomization: {
    id: 'app.AppCookiesConfig.cookiesCustomization',
    defaultMessage: 'Customization cookies',
  },
  descriptionCookiesCustomization: {
    id: 'app.AppCookiesConfig.descriptionCookiesCustomization',
    defaultMessage:
      'With these cookies we can adapt the display of the website and personalize your options.',
  },
  cookiesAnalytical: {
    id: 'app.AppCookiesConfig.cookiesAnalytical',
    defaultMessage: 'Analytical cookies',
  },
  descriptionCookiesAnalytical: {
    id: 'app.AppCookiesConfig.descriptionCookiesAnalytical',
    defaultMessage:
      'With these cookies we can analyze your navigation on our website to carry out statistical studies on your use.',
  },
  cookiesPublicity: {
    id: 'app.AppCookiesConfig.cookiesPublicity',
    defaultMessage: 'Publicity cookies',
  },
  descriptionCookiesPublicity: {
    id: 'app.AppCookiesConfig.descriptionCookiesPublicity',
    defaultMessage:
      'With these cookies, we can customize the ads displayed for your tastes, preferences and navigation on our website, as well as display SM ads on third party websites.',
  },
  alwaysActive: {
    id: 'app.AppCookiesConfig.alwaysActive',
    defaultMessage: 'Always active',
  },
  allowed: {
    id: 'app.AppCookiesConfig.allowed',
    defaultMessage: 'Allowed',
  },
  notAllowed: {
    id: 'app.AppCookiesConfig.notAllowed',
    defaultMessage: 'Not allowed',
  },
  saveSettings: {
    id: 'app.AppCookiesConfig.saveSettings',
    defaultMessage: 'Save settings',
  },
  cancel: {
    id: 'app.logout.cancel',
    defaultMessage: 'Cancel',
  },
  logout: {
    id: 'app.logout.logout',
    defaultMessage: 'Logout',
  },
  confirmLogout: {
    id: 'app.logout.confirm',
    defaultMessage: 'Are you sure you want to logout?',
  },
  errorRequired: {
    id: 'app.error.required',
    defaultMessage: 'Required field.',
  },
  errorAlphanumeric: {
    id: 'app.error.alphanumeric',
    defaultMessage: 'Only alphanumeric characters allowed.',
  },
  errorInvalidEmail: {
    id: 'app.error.errorInvalidEmail',
    defaultMessage: 'Email invalid.',
  },
  errorFallback: {
    id: 'app.error.errorFallback',
    defaultMessage: 'Error.',
  },
  applications: {
    id: 'app.applications',
    defaultMessage: 'Applications',
  },
  generalPanelTRI: {
    id: 'app.generalPanelTRI',
    defaultMessage: 'General Panel TRI',
  },
  titleOptin: {
    id: 'app.modalOptIn.titleOptin',
    defaultMessage: 'Welcome, {userName}',
  },
  subtitleOptin: {
    id: 'app.modalOptIn.subtitleOptin',
    defaultMessage: 'To continue you need to agree to our </br> Terms of Use and Privacy Policy',
  },
  readTerms: {
    id: 'app.modalOptIn.readTerms',
    defaultMessage:
      "I read and accept the <a style='color:blue; text-decoration:underline' href='http://linkte.me/politicaprivacidadeapp' target='_blank'>conditions of use</a> and the <a style='color:blue; text-decoration:underline' href='http://linkte.me/politicaprivacidadeapp' target='_blank'>privacy policy</a>.",
  },
  receiveCommercial: {
    id: 'app.modalOptIn.receiveCommercial',
    defaultMessage: 'I wish to receive commercial communications from the SM Group.',
  },
  submit: {
    id: 'app.modalOptIn.submit',
    defaultMessage: 'Submit',
  },
  mustAcceptTerms: {
    id: 'app.modalOptIn.error.mustAcceptTerms',
    defaultMessage: 'Must Accept Terms and Conditions',
  },
  titleNewAccess: {
    id: 'app.modalFirstAccess.titleNewAccess',
    defaultMessage: 'Welcome, {firstName}',
  },
  subtitleNewAccess: {
    id: 'app.modalFirstAccess.subtitleNewAccess',
    defaultMessage:
      'This will be your first login, so you will need to change your password. To proceed, change your password below',
  },
  continue: {
    id: 'app.modalFirstAccess.continue',
    defaultMessage: 'Continue',
  },
  genericError: {
    id: 'app.modalFirstAccess.genericError',
    defaultMessage: 'An error ocurred, please try again later.',
  },
  confirmedChangePassword: {
    id: 'app.modalFirstAccess.confirmedChangePassword',
    defaultMessage: 'Password changed with success',
  },
  sidebarReportCard: {
    id: 'app.sidebar.reportCard',
    defaultMessage: 'Report Card',
  },
  managerDashboard: {
    id: 'app.managerDashboard',
    defaultMessage: 'Manager Panel',
  },
});
